import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "../data/content";

export default function Ribbon() {
  return (
    <div data-testid="editorial-marquee" className="bg-[#1A1A1A] border-y border-[#F9F9F6]/10 py-7 overflow-hidden">
      <Marquee speed={30} gradient={false}>
        {MARQUEE_WORDS.concat(MARQUEE_WORDS).map((w, i) => (
          <span key={i} className="font-serif-e italic text-3xl md:text-4xl text-[#F9F9F6]/80 mx-12 whitespace-nowrap">
            {w} <span className="text-[#D4AF37] not-italic text-2xl align-middle ml-12">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
